export { default } from './component';


// WEBPACK FOOTER //
// ./components/Agile/feature/index.js